import React, { useState, Fragment, useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Card, CardBody, CardHeader, Form, FormGroup, Input, Label, Row, Col, Modal, ModalBody, ModalHeader, Button } from 'reactstrap';
import { Breadcrumbs, Btn, H4 } from '../../../../AbstractElements';
import DataTable from 'react-data-table-component';
import CommonModal from '../../../Common/Component/CommonModal';
import RequiredField from '../../../../Constant';
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2';
import { DoctorDepartmentList, CreateDoctorDepartment, UpdateDoctorDepartment, DeleteDoctorDepartment } from '../../../../apiController';
import { roles_permissions } from '../../../../Layout/Sidebar/Menu';

const DoctorDepartment = () => {

  const permission = roles_permissions.find(module=> module.module_name === "Doctor Department")

  const [Large, setLarge] = useState(false);
  const [department, setDepartment] = useState([]);
  const [formdata, setFormdata] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelet, setToggleDelet] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');

  const handleSearchKeyword = (keyword) => {
    setSearchKeyword(keyword);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue
  } = useForm();

  const LargeModaltoggle = () => {
    setLarge(!Large);
    reset({ doctordepartment: '', description: '' });
    if (!formdata.id) {
      setFormdata({});
    }
  };

  const handleEdit = (row) => {
    console.log(row)
    setFormdata({ id: row.id, doctordepartment: row.title, description: row.description });
    setLarge(!Large);
    // reset({ doctordepartment: row.title, description: row.description });
    setValue('doctordepartment',row.title)
    setValue('description',row.description)
    setValue('id',row.id)
  };

  const doctordepartmentData = department.map((row, ind) => ({
    ind: ind+1,
    id: row.id,
    doctordepartment: row.title,
    description: row.description,
    action: (
      <span key={ind}>
        <Btn
          attrBtn={{
            style: { width: 60, fontSize: 14, padding: 4 },
            color: 'success',
            className: 'btn btn-xs',
            type: 'button',
            onClick: () => handleEdit(row),
          }}
        >
          Edit
        </Btn>
      </span>
    ),
  }));

  const tableColumns = [
    {
      name: '#',
      selector: row => row['ind'],
      sortable: true,
      center: false,
    },
    {
      name: 'Department',
      selector: row => row['doctordepartment'],
      sortable: true,
      center: false,
    },
    {
      name: 'Description',
      selector: row => row['description'],
      sortable: true,
      center: false,
    },
    // {
    //   name: 'Action',
    //   selector: row => row.action,
    //   sortable: false,
    //   center: true,
    // },
  ];

  if(permission?.edit_access){
    tableColumns.push({
      name: "Action",
      selector: (row) => row["action"],
      sortable: false,
      center: true,
    });
  }

  

  const handleRowSelected = useCallback(state => {
    setSelectedRows(state.selectedRows);
  }, []);




  const handleSaveForm = async (data) => {
    console.log(data)
    const formattedData = {
      title: data.doctordepartment,
      description: data.description,
      id: data.id
    };

    console.log(formdata)

    try {
        if (formdata.id) {
            const response = await UpdateDoctorDepartment(formattedData);
            if (response.status === true) {
              setDepartment(prev => prev.map(item => item.id === formdata.id ? { ...item, name: formattedData.name } : item));
                toast.success('Updated Successfully!', { position: toast.POSITION.TOP_CENTER });

                setTimeout(() => {
                  window.location.reload();
                  }, 2000);
            }
        } else {
            const response = await CreateDoctorDepartment(formattedData);
            if (response.status === true) {
              setDepartment(prev => [...prev, response.data]);
                toast.success('Created Successfully!', { position: toast.POSITION.TOP_CENTER });
            }
        }
        fetchDoctorDepartment();
        LargeModaltoggle();
    } catch (error) {
        toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
    }
    reset({ doctordepartment: '', description: '' });
};


const handleDelete = async () => {
  const result = await SweetAlert.fire({
    title: 'Are you sure you want to delete?',
    cancelButtonText: 'No!',
    confirmButtonText: 'Yes!',
    reverseButtons: true,
    showCancelButton: true,
  });

  if (result.isConfirmed) {
    try {
      const selectedIds = selectedRows.map(row => row.id); 
      await Promise.all(selectedIds.map(id => DeleteDoctorDepartment(id)));
      setDepartment(department.filter(item => !selectedIds.includes(item.id)));
      setSelectedRows([]);
      toast.success('Deleted Successfully!', { position: toast.POSITION.TOP_CENTER });
      fetchDoctorDepartment()
    } catch (error) {
      toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
    }
  }
};

const fetchDoctorDepartment = async () => {
  const response = await DoctorDepartmentList();
  if (response.status === true) {
    setDepartment(response.data);
  }
};

  useEffect(() => {
    fetchDoctorDepartment();
  }, []);

  return (
    <Card>
      <Breadcrumbs mainTitle='Doctor Department' parent='Dashboard' title='Doctor Department' />
      <CardHeader className='card-no-border'>
        <div className='header-top'>
          <Fragment>
            <div className="search">
              <Form className="theme-form">
                <FormGroup className="form-group">
                  <div className="input-group">
                    <Input
                      className="form-control"
                      type="text"
                      placeholder="search"
                      value={searchKeyword}
                      onChange={(e) => handleSearchKeyword(e.target.value)}
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">
                        <i className="fa fa-search"></i>
                      </span>
                    </div>
                  </div>
                </FormGroup>
              </Form>
            </div>
          </Fragment>
          <div className='card-header-right-icon'>
          {permission?.create_access &&   <Btn attrBtn={{ color: 'light-primary', className: 'btn badge-light-primary', onClick: LargeModaltoggle }}>+ Add Doctor Department</Btn>}
            {/* <CommonModal isOpen={Large} title={"Doctor Department"} toggler={LargeModaltoggle} size="lg"  onSave={handleSaveForm} formdata={formdata}> */}
            <Modal isOpen={Large} title={"Doctor Department"} toggler={LargeModaltoggle} size="lg">
            {/* <CommonModal isOpen={Large} title={"Doctor Department"} toggler={LargeModaltoggle} size="lg"  onSave={handleSaveForm} formdata={formdata}> */}
            <ModalHeader>Doctor Department</ModalHeader>
            <ModalBody>
            <Form
        onSubmit={handleSubmit(handleSaveForm)}
        className="form-bookmark needs-validation"
      >
              <Row>
                <Col sm="12">
                  <FormGroup className="mb-3">
                    <Label htmlFor="doctordepartment">Doctor Department <RequiredField /></Label>
                    <input className={`form-control ${errors.doctordepartment && "is-invalid"}`} id="doctordepartment" type="text" name="doctordepartment" defaultValue={formdata.doctordepartment || ""} {...register("doctordepartment", { required: true })} />
                    <span className="text-danger">{errors.doctordepartment && "Doctor Department is required"}</span>
                  </FormGroup>
                </Col>
                <Col sm="12">
                  <FormGroup className="mb-3">
                    <Label htmlFor="description">Description <RequiredField /></Label>
                    <input className={`form-control ${errors.description && "is-invalid"}`} id="description" type="text" name="description" defaultValue={formdata.description || ""} {...register("description", { required: true })} />
                    <span className="text-danger">{errors.description && "Description is required"}</span>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
              <div className="text-end btn-mb mt-5">
              <Button
                className="secondary me-2"
                onClick={() =>
                  {setLarge(!Large); reset()}
                }
              >
                {'Cancel'}
              </Button>
              <Button className="primary" type="submit">
                {'Submit'}
              </Button>
            </div>
              </Row>
              </Form>
              </ModalBody>
            </Modal>
          </div>
        </div>
      </CardHeader>
      <CardBody className='pt-0 campaign-table'>
        <div className='recent-table table-responsive currency-table'>
          <Fragment>
            {selectedRows.length !== 0 &&
              <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                <H4 attrH4={{ className: 'text-muted m-0' }}>Delete Selected Data..!</H4>
                <Btn attrBtn={{ color: 'danger', onClick: handleDelete }}>Delete</Btn>
              </div>
            }
            <DataTable
              data={doctordepartmentData}
              columns={tableColumns}
              striped={true}
              center={true}
              pagination
              selectableRows = {permission?.delete_access}
              onSelectedRowsChange={handleRowSelected}
              clearSelectedRows={toggleDelet}
            />
          </Fragment>
        </div>
      </CardBody>
    </Card>
  );
}

export default DoctorDepartment;
